import React from 'react';
import theme from 'shared/constants/theme.json';

export default () => {
  const textSecondary = theme['text-color-secondary'];
  const textColor = theme['text-color'];
  const shadowColor = theme['shadow-color'];
  const borderColor = theme['border-color-base'];
  const primaryColor = theme['primary-color'];

  return (
    <svg width="230" height="280" viewBox="0 0 230 280" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="229" height="279" fill="white" />
      <path d="M46.7965 23.9025H183.203M84.632 40.4879H144.372" stroke={textSecondary} strokeWidth="3" />
      <path d="M12.448 60.9878H217.552V139.012H12.448V60.9878Z" stroke={textSecondary} />
      <path d="M21.9048 162.927H56.7532V160.976H21.9048V162.927Z" fill={textSecondary} />
      <path d="M60.7359 170.732H15.9307V169.756H60.7359V170.732Z" fill={textSecondary} />
      <path d="M55.7576 182.439H15.9307V181.463H55.7576V182.439Z" fill={textSecondary} />
      <path d="M15.9307 194.146H60.7359V193.171H15.9307V194.146Z" fill={textSecondary} />
      <path d="M60.7359 205.854H15.9307V204.878H60.7359V205.854Z" fill={textSecondary} />
      <path d="M15.9307 174.634H50.7792V173.659H15.9307V174.634Z" fill={textSecondary} />
      <path d="M50.7792 186.342H15.9307V185.366H50.7792V186.342Z" fill={textSecondary} />
      <path d="M15.9307 198.049H50.7792V197.073H15.9307V198.049Z" fill={textSecondary} />
      <path d="M50.7792 209.756H15.9307V208.781H50.7792V209.756Z" fill={textSecondary} />
      <path d="M15.9307 178.537H60.7359V177.561H15.9307V178.537Z" fill={textSecondary} />
      <path d="M55.7576 190.244H15.9307V189.268H55.7576V190.244Z" fill={textSecondary} />
      <path d="M15.9307 201.951H55.7576V200.976H15.9307V201.951Z" fill={textSecondary} />
      <path d="M60.7359 213.659H15.9307V212.683H60.7359V213.659Z" fill={textSecondary} />
      <path d="M99.5671 162.927H134.416V160.976H99.5671V162.927Z" fill={textSecondary} />
      <path d="M138.398 170.732H93.5931V169.756H138.398V170.732Z" fill={textSecondary} />
      <path d="M133.42 182.439H93.5931V181.463H133.42V182.439Z" fill={textSecondary} />
      <path d="M93.5931 194.146H138.398V193.171H93.5931V194.146Z" fill={textSecondary} />
      <path d="M138.398 205.854H93.5931V204.878H138.398V205.854Z" fill={textSecondary} />
      <path d="M93.5931 174.634H128.442V173.659H93.5931V174.634Z" fill={textSecondary} />
      <path d="M128.442 186.342H93.5931V185.366H128.442V186.342Z" fill={textSecondary} />
      <path d="M93.5931 198.049H128.442V197.073H93.5931V198.049Z" fill={textSecondary} />
      <path d="M128.442 209.756H93.5931V208.781H128.442V209.756Z" fill={textSecondary} />
      <path d="M93.5931 178.537H138.398V177.561H93.5931V178.537Z" fill={textSecondary} />
      <path d="M133.42 190.244H93.5931V189.268H133.42V190.244Z" fill={textSecondary} />
      <path d="M93.5931 201.951H133.42V200.976H93.5931V201.951Z" fill={textSecondary} />
      <path d="M138.398 213.659H93.5931V212.683H138.398V213.659Z" fill={textSecondary} />
      <path d="M177.229 162.927H212.078V160.976H177.229V162.927Z" fill={textSecondary} />
      <path d="M216.061 170.732H171.255V169.756H216.061V170.732Z" fill={textSecondary} />
      <path d="M211.082 182.439H171.255V181.463H211.082V182.439Z" fill={textSecondary} />
      <path d="M171.255 194.146H216.061V193.171H171.255V194.146Z" fill={textSecondary} />
      <path d="M216.061 205.854H171.255V204.878H216.061V205.854Z" fill={textSecondary} />
      <path d="M171.255 174.634H206.104V173.659H171.255V174.634Z" fill={textSecondary} />
      <path d="M206.104 186.342H171.255V185.366H206.104V186.342Z" fill={textSecondary} />
      <path d="M171.255 198.049H206.104V197.073H171.255V198.049Z" fill={textSecondary} />
      <path d="M206.104 209.756H171.255V208.781H206.104V209.756Z" fill={textSecondary} />
      <path d="M171.255 178.537H216.061V177.561H171.255V178.537Z" fill={textSecondary} />
      <path d="M211.082 190.244H171.255V189.268H211.082V190.244Z" fill={textSecondary} />
      <path d="M171.255 201.951H211.082V200.976H171.255V201.951Z" fill={textSecondary} />
      <path d="M216.061 213.659H171.255V212.683H216.061V213.659Z" fill={textSecondary} />
      <rect width="230" height="280" fill={shadowColor} />
      <g filter="url(#filter0_d)">
        <rect x="25" y="40" width="180" height="200" rx="2" fill="white" />
        <line x1="41" y1="191.5" x2="131" y2="191.5" stroke={textColor} strokeWidth="3" />
        <line x1="49" y1="202.5" x2="94" y2="202.5" stroke={textSecondary} />
        <line x1="49" y1="208.5" x2="81" y2="208.5" stroke={textSecondary} />
        <line x1="49" y1="214.5" x2="99" y2="214.5" stroke={textSecondary} />
        <circle cx="43" cy="202" r="2" fill="white" />
        <circle cx="43" cy="202" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
        <circle cx="43" cy="208" r="2" fill="white" />
        <circle cx="43" cy="208" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
        <circle cx="43" cy="214" r="2" fill="white" />
        <circle cx="43" cy="214" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
        <line x1="41" y1="154.5" x2="131" y2="154.5" stroke={textColor} strokeWidth="3" />
        <line x1="51" y1="164.5" x2="96" y2="164.5" stroke={textSecondary} />
        <line x1="51" y1="170.5" x2="83" y2="170.5" stroke={textSecondary} />
        <line x1="51" y1="176.5" x2="91" y2="176.5" stroke={textSecondary} />
        <rect x="41" y="162" width="4" height="4" fill="white" />
        <rect x="41.1" y="162.1" width="3.8" height="3.8" stroke={textSecondary} strokeWidth="0.2" />
        <rect x="41" y="168" width="4" height="4" fill="white" />
        <rect x="41.1" y="168.1" width="3.8" height="3.8" stroke={textSecondary} strokeWidth="0.2" />
        <rect x="41" y="174" width="4" height="4" fill="white" />
        <rect x="41.1" y="174.1" width="3.8" height="3.8" stroke={textSecondary} strokeWidth="0.2" />
        <line x1="41" y1="108.5" x2="106" y2="108.5" stroke={textColor} strokeWidth="3" />
        <rect x="41" y="115" width="136" height="26" rx="1" fill="white" />
        <rect x="41.1" y="115.1" width="135.8" height="25.8" rx="0.9" stroke={textSecondary} strokeWidth="0.2" />
        <line x1="41" y1="70.5" x2="131" y2="70.5" stroke={textColor} strokeWidth="3" />
        <line x1="49" y1="81.5" x2="94" y2="81.5" stroke={textSecondary} />
        <line x1="49" y1="87.5" x2="81" y2="87.5" stroke={textSecondary} />
        <line x1="49" y1="93.5" x2="99" y2="93.5" stroke={textSecondary} />
        <circle cx="43" cy="81" r="2" fill="white" />
        <circle cx="43" cy="81" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
        <circle cx="43" cy="87" r="2" fill="white" />
        <circle cx="43" cy="87" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
        <circle cx="43" cy="93" r="2" fill="white" />
        <circle cx="43" cy="93" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
        <path d="M25 41C25 40.4477 25.4477 40 26 40H204C204.552 40 205 40.4477 205 41V55H25V41Z" fill={primaryColor} />
        <rect x="25.5" y="40.5" width="179" height="199" rx="1.5" stroke={borderColor} />
      </g>
      <rect x="0.5" y="0.5" width="229" height="279" stroke={borderColor} />
      <defs>
        <filter id="filter0_d" x="21" y="40" width="188" height="208" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>

  );
};
